import { addClasses, innerText, queryAll, removeClasses } from 'lambda-dom'
import { isNil } from 'ramda'

import { capitalize } from '@app-helpers'
import { bugsnagClient, push } from '@app-services'
import { LocalizedLink, TranslatedElement, TranslatedPlaceholder, TranslateToggle } from './speak-up.types'


export function deactivateElementOnBodyClick(element: Element, excludedTargetSelector: string): void {
    document.body.addEventListener('click', ({ target }) => {
        if (target instanceof Element && isNil(target.closest(excludedTargetSelector))) {
            removeClasses('active')(element)
        }
    })
}

export function translate(locale: string): void {
    for (const translatedElement of queryAll<TranslatedElement>('[data-speakup-translations]')) {
        try {
            const translations = JSON.parse(translatedElement.dataset.speakupTranslations) || {}
            translatedElement.innerHTML = translations[locale]
        } catch (e: unknown) {
            bugsnagClient.notify(e as string)
        }
    }

    for (const localeButton of queryAll<TranslateToggle>('[data-speakup-localize]')) {
        if (localeButton.dataset.speakupLocalize === locale) {
            addClasses('active')(localeButton)
            queryAll('[data-current-locale="full"]')
                .map((element) => innerText(localeButton.innerText)(element as HTMLElement))
            queryAll('[data-current-locale="abbr"]')
                .map((element) => innerText(capitalize(locale))(element as HTMLElement))
        } else {
            removeClasses('active')(localeButton)
        }
    }

    for (const input of queryAll<TranslatedPlaceholder>('[data-placeholder-translations]')) {
        try {
            const translations = JSON.parse(input.dataset.placeholderTranslations) || {}
            input.placeholder = translations[locale]
            input.setAttribute('aria-label', translations[locale])
        } catch (e: unknown) {
            bugsnagClient.notify(e as string)
        }
    }

    for (const link of queryAll<LocalizedLink>('[data-localized-link]')) {
        link.href = `${link.dataset.url}?l=${locale}`
    }

    push.patchQueryParams({
        l: locale,
    }, true, { encode: false })
}

export function getSpeakUpUrlForLanguage(language: string): string {
    const urlPartOne = 'https://aalberts.speakup.report/'
    const urlPartThree = '/start/home'

    const languages: Record<string, string> = {
        cn: 'zh-Hans',
        de: 'de-DE',
        en: 'en-GB',
        es: 'es',
        fr: 'fr-FR',
        it: 'it',
        nl: 'nl-NL',
        pl: 'pl',
    }

    const languageToUse = languages[language] || languages.en

    return urlPartOne + languageToUse + urlPartThree
}
